import { useEffect, useMemo, useState } from "react";
import { loadStoredSession } from "@itaas/core/auth/auth.storage";
import { buildModuleHandoffUrl } from "@itaas/core/modules/suite-navigation";
import { getModuleBaseUrl, type IntegratedModuleId } from "@/core/config";

const MODULE_HINTS: Record<IntegratedModuleId, string> = {
  rh: "Vérifiez que ITaaS RH tourne sur le port attendu.",
  inventory: "Vérifiez que l'API inventory (:3020) et le web (:3021) sont démarrés.",
  billing: "Vérifiez que ITaaS Billing tourne sur le port attendu.",
};

interface ModuleEmbedFrameProps {
  moduleId: IntegratedModuleId;
  targetPath: string;
  title: string;
}

export function ModuleEmbedFrame({ moduleId, targetPath, title }: ModuleEmbedFrameProps) {
  const [src, setSrc] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const baseUrl = useMemo(() => getModuleBaseUrl(moduleId), [moduleId]);

  useEffect(() => {
    const session = loadStoredSession();
    if (!session) {
      setError("Session introuvable — reconnectez-vous via ITaaS Suite.");
      return;
    }
    setSrc(
      buildModuleHandoffUrl(baseUrl, "/auth/handoff", session, targetPath),
    );
    setError(null);
  }, [baseUrl, targetPath]);

  if (error) {
    return (
      <div className="alert alert-warning m-3">
        {error}
        <div className="small mt-1">{MODULE_HINTS[moduleId]}</div>
      </div>
    );
  }

  return (
    <div className="ph-embed">
      <iframe
        key={src ?? "loading"}
        title={title}
        src={src ?? undefined}
        className="ph-embed-frame"
      />
      {!src && (
        <div className="ph-embed-loading text-muted">Chargement du module…</div>
      )}
    </div>
  );
}
